import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

interface QuickLinkItem {
  label: string;
  to: string;
}

interface FooterQuickProps {
  quickLinks: QuickLinkItem[];
}

const FooterQuick = ({ quickLinks }: FooterQuickProps) => {
  return (
<ul className="space-y-1 font-semibold">
  {quickLinks.map((item) => (
    <li key={item.label}>
      <Link
        to={item.to}
        className="text-black transition-colors flex items-center justify-center md:justify-start gap-2"
      >
        <ChevronRight className="h-4 w-4" />
        {item.label}
      </Link>
    </li>
  ))}
</ul>
  );
};

export default FooterQuick;